export const ANNOUNCEMENTS_SET_TELERADIOLOGY_SEEN = 'ANNOUNCEMENTS_SET_TELERADIOLOGY_SEEN' as const;

export const setAnnouncementsTeleradiologySeen = (isSeen: boolean) => ({
  type: ANNOUNCEMENTS_SET_TELERADIOLOGY_SEEN,
  isSeen,
});
